


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Vehicle } from '../../models';
@Component
export default class ItemVehicle extends Vue {
    @Prop({ default: null }) vehicle: Vehicle;
    @Prop({ default: false }) isSelected: boolean;
    @Prop({ default: false }) readonly: boolean;
}
